module.exports = __webpack_public_path__ + "static/media/coins.c2d439af.svg";